export const PAYMENT_MODES = [
  "Bank Transfer",
  "Cheque",
  "NEFT",
  "RTGS",
  "IMPS",
  "Wire Transfer",
];

export function emptyTransaction() {
  return {
    transaction_id: "",
    transaction_date: "",
    utr_number: "",
    bank_account_number: "",
    bank_name: "",
    payment_mode: "",
    remarks: "",
  };
}

export function num(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function currency(value) {
  return `₹${new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num(value))}`;
}

export function percent(value) {
  return `${num(value).toFixed(2)}%`;
}

export function maskAccountNumber(accountNumber) {
  if (!accountNumber) return "—";
  const visible = accountNumber.slice(-4);
  const stars = "*".repeat(Math.max(0, accountNumber.length - 4));
  return `${stars}${visible}`;
}

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export function periodLabel(month, year, fortnight) {
  const fn = fortnight ? ` - FN${fortnight}` : "";
  return `${String(month).padStart(2, "0")}/${year}${fn}`;
}

export function monthName(month) {
  return MONTH_NAMES[month - 1] || "";
}
